import { Box, Typography } from "@mui/material";
import React from "react";

import * as homeStyles from "styles/Home.css";

const Requirements = () => {
  return (
    <Box>
      <h2 className={homeStyles.heading} style={{ marginBottom: "2rem" }}>
        Requirements
      </h2>
      <Typography className={homeStyles.subtitle}>
        To use our service, you need to upload a CSV or similar format file. The
        file should contain at least three columns: date, amount and details.
        The date column should contain dates in the format YYYY-MM-DD or
        YYYY/MM/DD. The amount column should contain numbers.
      </Typography>
    </Box>
  );
};

export default Requirements;
